import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Icon } from 'semantic-ui-react';
import TableHeader from '@/components/table/TableHeader';

const RequestMetricsTableHeader = ({ numberOfColumns }) => {
  const intl = useIntl();
  return (
    <TableHeader className="aridhia-request-metrics-table-header-row" numberOfColumns={numberOfColumns}>
      <span>
        <Icon
          name="key"
          title={intl.formatMessage({ id: 'dataset.settings.metrics.requests.title' })}
          className="primary"
        />
        <FormattedMessage id="dataset.settings.metrics.requests.title" />
      </span>
    </TableHeader>
  );
};

export default RequestMetricsTableHeader;
